(ns frontend.view.settings2.module-management.mcp-terms.event
  "Re-frame events for the acceptance of the MCP terms. The tenant admin
   activates an MCP module only through :mcp-enablement/accept-terms. The
   backend then records who accepted the terms and when."
  (:require
   [common.endpoints.mcp-enablement :as models]
   [common.localization :as loc]
   [frontend.global-events.toast :as toast]
   [frontend.logging :as logging]
   [frontend.state.current-session :as session]
   [fx.ajax :as ajax]
   [re-frame.core :as rf]
   [ui.data.tenant.event :as tenant-event]))

(defn accept-request
  "The :mcp-enablement/accept-terms body for activating `module`."
  [module]
  {:modules       [module]
   :accepted?     true
   :terms-version models/terms-version})

(defn- accept
  [_cofx [_ {:keys [module]}]]
  {::ajax/send {:operation :mcp-enablement/accept-terms
                :body      (accept-request module)
                :on-ok     [::accepted]
                :on-error  [::accept-failed]}})

(defn- accepted
  [_cofx [_ resp]]
  {::set-session-tenant-modules (get-in resp [:body :modules])
   ::toast/success              (loc/tr :settings/mcp-terms-accepted-toast)})

(defn- accept-failed
  [_cofx [_ err]]
  (logging/error "Failed to accept the MCP terms" err)
  {::toast/error (or (:message err)
                     (get-in err [:response :message])
                     (loc/tr :settings/mcp-terms-accept-failed))})

(rf/reg-event-fx ::accept accept)

(rf/reg-event-fx ::accepted accepted)

(rf/reg-event-fx ::accept-failed accept-failed)

(rf/reg-fx
 ::set-session-tenant-modules
 (fn [modules]
   (let [tenant-id (:db/id @session/tenant)]
     (swap! session/entities assoc-in [tenant-id :tenant/modules] modules)
     (swap! session/tenant assoc :tenant/modules modules)
     ;; The ui.* subscriptions read the tenant from the re-frame db. The
     ;; server push updates it too, but only after the response.
     (rf/dispatch [::tenant-event/update-tenant @session/tenant]))))
